import { Box, Button, Checkbox, FormControlLabel, FormGroup, TextField, Typography, } from '@mui/material'
import { useState } from 'react';
import { createCustomer } from '../../api/customersAPI';
import NavBar from '../layout/NavBar';

export default function AddCustomer() {
  // Hold form values
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');
  const [taxExempt, setTaxExempt] = useState(false);
  const [acceptsTexts, setAcceptsTexts] = useState(false);
  const [acceptsEmails, setAcceptsEmails] = useState(false);
  const [isFlagged, setIsFlagged] = useState(false);
  const [customerNotes, setCustomerNotes] = useState('');

  // Add error states
  const [formErrors, setFormErrors] = useState({});

  async function handleSubmit(event) {
    event.preventDefault();
    // Post the value of the form
    let values = {
      'first_name': firstName,
      'last_name': lastName,
      'phone': phoneNumber,
      'email': email,
      'tax_exempt': taxExempt,
      'accepts_emails': acceptsEmails,
      'accepts_texts': acceptsTexts,
      'flagged': isFlagged,
      'notes': customerNotes
    };
    console.log('Attempting to submit these values:');
    console.log(values);
    try {
      let response = await createCustomer(values);
      if (response.status === 201) {
        let newCustID = response.data.id;
        window.location.replace(`/customers/${newCustID}`)
      }
    } catch (error) {
      console.error(error);
      if (error.response && error.response.data) {
        setFormErrors(error.response.data);
      }
    }
  }

  return (
    <Box
      component='form'
      noValidate
      autoComplete='off'
      sx={{
        textAlign: 'center',
        margin: 'auto',
        minWidth: '519px',
        maxWidth: '75%',
      }}
    >
      <Typography variant='h2' align='center'>Add Customer</Typography>
      <NavBar active='Customers' />
      <FormGroup>
        <TextField
          required
          id='first-name'
          label='First Name'
          variant='outlined'
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          sx={{ mb: 1 }}
          error={!!formErrors.first_name}
          helperText={formErrors.first_name}
        />
        <TextField
          required
          id='last-name'
          label='Last Name'
          variant='outlined'
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          sx={{ mb: 1 }}
          error={!!formErrors.last_name}
          helperText={formErrors.last_name}
        />
        <TextField
          required
          id='phone-number'
          label='Phone Number'
          variant='outlined'
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          sx={{ mb: 1 }}
          error={!!formErrors.phone}
          helperText={formErrors.phone}
        />
        <TextField
          id='email'
          label='Email'
          variant='outlined'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={{ mb: 1 }}
          error={!!formErrors.email}
          helperText={formErrors.email}
        />
        <FormControlLabel
          control={<Checkbox />}
          label='Tax Exempt'
          checked={taxExempt}
          onChange={(e) => setTaxExempt(!taxExempt)}
        />
        <FormControlLabel
          control={<Checkbox />}
          label='Accepts Texts'
          checked={acceptsTexts}
          onChange={(e) => setAcceptsTexts(!acceptsTexts)}
        />
        <FormControlLabel
          control={<Checkbox />}
          label='Accepts Emails'
          checked={acceptsEmails}
          onChange={(e) => setAcceptsEmails(!acceptsEmails)}
        />
        <FormControlLabel
          control={<Checkbox />}
          label='Flagged'
          checked={isFlagged}
          onChange={(e) => setIsFlagged(!isFlagged)}
        />
        <TextField
          id='customer-notes'
          label='Customer Notes'
          variant='outlined'
          multiline
          rows={4}
          value={customerNotes}
          onChange={(e) => setCustomerNotes(e.target.value)}
          sx={{ mb: 1 }}
          error={!!formErrors.customer_notes}
          helperText={formErrors.customer_notes}
        />
        <Button variant='contained' onClick={handleSubmit}>Submit</Button>
      </FormGroup>
    </Box>
  );
}